/* eslint-disable jsx-a11y/anchor-is-valid */
import { useCallback, useEffect, useMemo, useState } from 'react'
import InboxChatInner from './InboxChatInner'
import { useDispatch, useSelector } from 'react-redux'
import {
  getAllChat,
  GetAllData,
  getReplyInboxData,
  getRmsChat,
  GetRmsChatList,
  getSingleChat,
  getSingleRmsChat,
  GetSingleRmsChat,
  inboxArchiveFlag,
  InboxSmsBadge,
} from './InboxSlice/InboxSlice'
import { useDebounce } from '../../../../_metronic/helpers'
import NodataYet from '../../../Components/NodataYet'
import InsertNewData from '../../../Components/InsertNewData'
import RmsInbox from './RmsInbox'
import { DropdownButton, Dropdown, Tooltip, OverlayTrigger } from 'react-bootstrap'
import { getUserData } from '../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import { GetAllTeamList } from '../accounts/Overview/OverviewSlice/TeamListSlice'
import AssignedTags from '../Contacts/AllContactsList/Modal/AssignedTags'
import {
  GetContectData,
  optoutContact,
} from '../Contacts/AllContactsList/SubscriberSlice/SubscriberSlice'
import {PortalNotifiationBySuperAdmin} from '../../../Redux/AdminPanel/CommentSlice'
import {useLocation, useNavigate} from 'react-router-dom'
import {Group, Tag} from '../../../../services/cellcast.v2.types'
import {omit} from 'lodash'
import {useInboxCloseAllMutation, useInboxReadAllMutation} from '../../../../services/cellcast.v2'
import {AuthenticateUser} from '../../../Utils/_helpers/RoleAndPermission'
import ContactDetailPanel from '../Contacts/Components/ContactDetailPanel'
import { useLazyGetSingleReceiverMessageExportQuery } from '../../../../services/cellcast'
import { toast } from 'react-toastify'
import { ENV } from '../../../Utils/_helpers/EnvHelper'
import EditSingleSubscriber from '../Contacts/AllContactsList/Modal/EditSingleSubscriber'
import {ConversationItem, InboxHeader, QuickFiltersModal, BulkActionsDropdown} from './Components'
import {
  getSelectedConversations,
  toggleConversationSelection,
  assignConversation,
  bulkAssignConversations,
  bulkArchiveConversations,
  bulkUnsubscribeConversations,
  selectAllConversations,
  clearConversationSelection,
} from './InboxSlice/InboxSlice'
import {fetchAsyncUserDetails} from '../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {useInboxResponsive} from './useInboxResponsive'
import { stopLoading } from '../../../Redux/FrontEnd/Loading/LoadingSlice'


const API_DOMAIN = ENV().REACT_APP_DOMAIN

const InboxPage = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const {isMobile} = useInboxResponsive()
  const queryParams = new URLSearchParams(location.search)
  const receiver = queryParams.get('receiver')

  const OwnerId = useSelector(getUserData)?.user?._id
  const userData = useSelector(getUserData)?.user
  const roleName = useSelector(getUserData)?.user?.role
  const groupid: any = useSelector((state: any) => state?.subscriberData?.FieldName?.data?._id)
  const contactDetail = useSelector((state: any) => state?.subscriberData?.contectData?.data)

  const [inboxRead] = useInboxReadAllMutation()
  const [inboxClose] = useInboxCloseAllMutation()

  const [rmsChat, setRmsChat] = useState(false)
  const [firstTime, setFirstTime] = useState(false)
  const [selectedFilter, setSelectedFilter] = useState<
    | 'All Message'
    | 'Active Messages Only'
    | 'Flagged'
    | 'My Message'
    | 'Archived'
    | 'Unread'
    | 'Opened'
    | 'Subscribed'
    | 'Unsubscribed'
  >('Active Messages Only')
  const [sortOrder, setSortOrder] = useState<'ascend' | 'descend'>('descend')
  const [assigneeFilter, setAssigneeFilter] = useState<string | null>(null)
  const [queryData, setQueryData] = useState<any>({
    isBlocked: false,
    pageCount: 1,
    searchInput: '',
  })
  const [searchMode, setSearchMode] = useState<string>('by-filter')

  const messageData = useSelector(getAllChat)
  const rmsMessageData = useSelector(getRmsChat)
  const rmsSingleData = useSelector(getSingleRmsChat)
  const Teamlist = useSelector((state: any) => {
    const teamData = state?.teamlist?.TeamList?.items || []
    const user = state.userDetails.userDetails?.data?.user
    return [user, ...teamData]
  })

  // Bulk selection state
  const selectedConversations = useSelector(getSelectedConversations)
  const replyInboxData = useSelector(getReplyInboxData)
  const [number, setNumber] = useState<any>('')
  const [selectedNumberId, setSelectedNumberID] = useState('')
  const [selectedNumberTagId, setSelectedNumberTagID] = useState('')
  const [assignedTagsPopup, setAssignedTagsPopup] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [firstLoadInit, setFirstLoadInit] = useState(true)
  const [showQuickFilters, setShowQuickFilters] = useState(false)
  const [showBulkActions, setShowBulkActions] = useState(false)
  const [archive, setArchive] = useState({
    isFlagged: true,
    isArchived: false,
    isTicked: false,
  })
  const [nameOfSubscriber, setNameOfSubscriber] = useState<any>('')
  const [rmsId, setRmsId] = useState<any>('')
  const [messengerName, setMessengerName] = useState('')
  const [activeConversationId, setActiveConversationId] = useState<string | null>(null)
  const debouncedSearchTerm = useDebounce(queryData?.searchInput, 500)
  const chat = useSelector(getSingleChat)
  const [limit, setLimit] = useState(50)
  const [showDetailModal, setShowDetailModal] = useState(false)
  const [selectedDetailId, setSelectedDetailId] = useState('')
  // Track if we are waiting for an optimistic removal
  const [isOptimisticLoading, setIsOptimisticLoading] = useState(false)

  const changeChat = useCallback(
    (val: any, isFirstTime: boolean = false) => {
      // dispatch(
      //   GetSingleChat({
      //     page: 1,
      //     sortField: 'createdAt',
      //     sortOrder: 'descending',
      //     receiver: val,
      //     limit: 20,
      //     firstTime: isFirstTime,
      //   })
      // )
      setFirstTime(isFirstTime)
    },
    [setFirstTime]
  )

  const [exportSingleReceiverMessage, { data: exportSingleReceiverMessageData }] =
    useLazyGetSingleReceiverMessageExportQuery()

  const [editModal, setEditModal] = useState<{
    data: any
    toggle: boolean
    number?: string
    _id?: string
    tags: Tag[]
    group?: Group
  }>({
    data: '',
    toggle: false,
    tags: [],
  })

  const fetchData = useCallback(
    (OwnerId: any, rmsChat: any, queryData: any, assigneeFilter?: string | null) => {
      if (rmsChat) {
        dispatch(
          GetRmsChatList({
            // page: queryData?.pageCount,
            sortField: 'createdAt',
            sortOrder,
            // limit: 10,
          })
        )
      } else {
        const params: any = {
          page: 1,
          sortField: 'createdAt',
          sortOrder,
          size: limit,
          search: queryData?.searchInput,
          ...omit(queryData, ['pageCount', 'searchInput']),
        }

        // Add assignee filter if present
        if (assigneeFilter) {
          params.assigneeId = assigneeFilter
        }

        dispatch(GetAllData(params)).then(() => {
          setIsLoading(false)
        })
      }
      dispatch(GetAllTeamList({ ownerId: OwnerId }))
    },
    [dispatch, sortOrder, limit]
  )

  useEffect(() => {
    // dispatch(startLoadding())
    fetchData(OwnerId, rmsChat, queryData, assigneeFilter)
  }, [
    queryData.isArchived,
    queryData.isBlocked,
    queryData.isInboxRead,
    queryData.isAssignToMe,
    sortOrder,
    rmsChat,
    debouncedSearchTerm,
    limit,
    editModal.toggle,
    assigneeFilter,
    OwnerId,
    fetchData,
    queryData,
  ])

  useEffect(() => {
    if (number === '' && receiver) {
      dispatch(
        GetContectData({
          payload: { receiver: receiver },
        })
      )
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [receiver, number]);

  useEffect(() => {
    if (replyInboxData?.receiver) {
      const findData = messageData?.items?.find(
        (data: any) => data?.receiver === replyInboxData?.receiver
      )

      if (!!findData) {
        const name =
          findData?.contactgroupmaps?.fields
            .filter((it: any) => ['First Name', 'Last Name'].includes(it.name))
            .map((it: any) => it.value)
            .join(' ') || findData?.receiver
        changeChat(findData?.receiver)
        setNumber(findData?.receiver)
        setSelectedNumberID(findData?.contacts?._id)
        setSelectedNumberTagID(findData?.contactgroupmaps?._id)
        setArchive({
          isFlagged: findData?.contacts?.isFlagged,
          isArchived: findData?.contacts?.isArchived,
          isTicked: findData?.contacts?.isTicked,
        })
        setMessengerName(name)
      }
    }
  }, [replyInboxData, messageData, changeChat])

  useEffect(() => {
    if (!!number) {
      const findData = messageData?.items?.find((data: any) => data?.receiver == number)
      if (!!findData) {
        const name =
          findData?.contactgroupmaps?.fields
            ?.filter((it: any) => ['First Name', 'Last Name'].includes(it.name))
            .map((it: any) => it.value)
            .join(' ') || findData?.receiver
        changeChat(findData?.receiver)
        setNumber(findData?.receiver)
        setSelectedNumberID(findData?.contacts?._id)
        setSelectedNumberTagID(findData?.contactgroupmaps?._id)
        setArchive({
          isFlagged: findData?.contacts?.isFlagged,
          isArchived: findData?.contacts?.isArchived,
          isTicked: findData?.contacts?.isTicked,
        })
        setMessengerName(name)
      }
    }
  }, [changeChat, messageData, number])

  const changeRmsChat = (val: any) => {
    dispatch(
      GetSingleRmsChat({
        id: val,
      })
    )
  }

  // Handle effect when load this page and have query param : receiver
  // - wait all data finish to load
  // - find data base on receiver from query param
  // - set active selected inbox item to founded data
  useEffect(() => {
    if (!isLoading && firstLoadInit && receiver) {
      const findData = messageData?.items?.find((data: any) => data?.receiver === receiver)
      if (!!findData) {
        const name =
          findData?.contactgroupmaps?.fields?.find((key: any) => key.name === 'First Name')
            ?.value || findData?.receiver
        changeChat(findData?.receiver)
        setNumber(findData?.receiver)
        setSelectedNumberID(findData?.contacts?._id)
        setActiveConversationId(findData.contacts._id)
        setSelectedNumberTagID(findData?.contactgroupmaps?._id)
        setArchive({
          isFlagged: findData?.contacts?.isFlagged,
          isArchived: findData?.contacts?.isArchived,
          isTicked: findData?.contacts?.isTicked,
        })
        setMessengerName(name)
        setFirstLoadInit(false)
      } else if (contactDetail && !!contactDetail?.number) {
        const name =
          contactDetail?.fields
            .filter((it: any) => ['First Name', 'Last Name'].includes(it.name))
            .map((it: any) => it.value)
            .join(' ') || contactDetail?.number
        changeChat(contactDetail?.number)
        setNumber(contactDetail?.number)
        setSelectedNumberID(contactDetail?.contacts?._id)
        setSelectedNumberTagID(contactDetail?._id)
        setMessengerName(name)
        setFirstLoadInit(false)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contactDetail, messageData, firstLoadInit, isLoading, changeChat, location.search, number, receiver])

  const assignedTags = useMemo(
    () => (
      <AssignedTags
        checkList={[selectedNumberTagId]}
        show={assignedTagsPopup}
        handleClose={() => setAssignedTagsPopup(false)}
      />
    ),
    [assignedTagsPopup, selectedNumberTagId]
  )

  // const ContactDetail = useMemo(
  //   () => (
  //     <ContectDataModel
  //       show={showDetailModal}
  //       handleClose={() => setShowDetailModal(false)}
  //       setEditPopup={setEditModal}
  //     />
  //   ),
  //   [showDetailModal]
  // )

  const ContactDetail = useMemo(
    () => (
      <ContactDetailPanel
        show={showDetailModal}
        handleClose={() => {
          setShowDetailModal(false)
          setSelectedDetailId('')
        }}
        setEditPopup={setEditModal}
        contactId={selectedDetailId}
        group={groupid || ''}
      />
    ),
    [groupid, selectedDetailId, showDetailModal]
  )

  const EditContact = useMemo(
    () => <EditSingleSubscriber show={editModal} handleClose={setEditModal} />,
    [editModal]
  )

  const handleShowDetailModal = (number: string, contactId: string) => {
    dispatch(
      GetContectData({
        payload: { receiver: number, contcatId: contactId },
      })
    )
    setShowDetailModal(true)
    setSelectedDetailId(contactId)
  }

  // Handler functions for InboxFilters component
  const handleFilterChange = (
    filter:
      | 'All Message'
      | 'My Message'
      | 'Archived'
      | 'Unread'
      | 'Opened'
      | 'Subscribed'
      | 'Unsubscribed'
  ) => {
    const query: any = {
      pageCount: 1,
      searchInput: queryData?.searchInput || '',
    }

    switch (filter) {
      case 'All Message':
        query.isArchived = false
        break
      case 'My Message':
        query.isAssignToMe = true
        break
      case 'Archived':
        query.isArchived = true
        break
      case 'Unread':
        query.isInboxRead = false
        break
      case 'Opened':
        query.isInboxRead = true
        break
      case 'Subscribed':
        query.isBlocked = false
        break
      case 'Unsubscribed':
        query.isBlocked = true
        break
      default:
        query.isBlocked = false
        break
    }

    setSelectedFilter(filter)
    setQueryData(query)
  }

  const handleAssigneeFilterChange = (assigneeId: string | null) => {
    setAssigneeFilter(assigneeId)
  }

  const handleSortOrderChange = (order: 'ascend' | 'descend') => {
    setSortOrder(order)
  }

  const handleSearchInputChange = (search: string) => {
    let query = {
      ...queryData,
      searchInput: search,
    }
    if (searchMode === 'all') {
      query = { pageCount: queryData?.pageCount, searchInput: search }
    }
    setQueryData(query)
  }

  // Handler functions for ConversationItem component
  const handleConversationSelect = (conversationId: string, selected: boolean) => {
    dispatch(toggleConversationSelection(conversationId))
  }

  const handleConversationClick = (conversation: any) => {
    const name =
      conversation?.contactgroupmaps?.fields
        ?.filter((it: any) => ['First Name', 'Last Name'].includes(it?.name))
        ?.map((it: any) => it?.value)
        ?.join(' ') || conversation?.receiver

    const queryParams = new URLSearchParams(location.search)
    queryParams.set('receiver', conversation?.receiver)

    // Push new URL with updated query
    navigate(`${location.pathname}?${queryParams.toString()}`, {replace: true})

    setNumber(conversation?.receiver)
    setSelectedNumberID(conversation?.contacts?._id)
    setSelectedNumberTagID(conversation?.contactgroupmaps?._id)
    setActiveConversationId(conversation.contacts._id)
    setArchive({
      isFlagged: conversation?.contacts?.isFlagged,
      isArchived: conversation?.contacts?.isArchived,
      isTicked: conversation?.contacts?.isTicked,
    })

    dispatch(
      inboxArchiveFlag({
        receiver: conversation?.receiver,
        data: {
          isFlagged: conversation?.contacts?.isFlagged,
          isArchived: conversation?.contacts?.isArchived,
          isTicked: conversation?.contacts?.isTicked,
          isInboxRead: true,
        },
        limit,
      })
    ).then((res: any) => {
      fetchData(OwnerId, rmsChat, queryData, assigneeFilter)
      dispatch(InboxSmsBadge())
    })
    setMessengerName(name)
  }

  const handleConversationAssign = (conversationId: string, assignee: any) => {
    dispatch(assignConversation({ conversationId, assigneeId: assignee._id })).then(() => {
      fetchData(OwnerId, rmsChat, queryData, assigneeFilter)
    })
  }

  const handleConversationTag = (conversationId: string) => {
    // Find the conversation to get the tag ID
    const conversation = messageData?.items?.find(
      (item: any) => item.contacts._id === conversationId
    )
    if (conversation) {
      setSelectedNumberTagID(conversation.contactgroupmaps?._id)
      setAssignedTagsPopup(true)
    }
  }

  const handleConversationUnsubscribe = (conversationId: string) => {
    dispatch(
      optoutContact({
        data: {
          ids: [conversationId],
        },
        id: groupid,
      })
    ).then(() => {
      fetchData(OwnerId, rmsChat, queryData, assigneeFilter)
    })
  }

  const handleConversationArchive = (conversationId: string) => {
    const conversation = messageData?.items?.find(
      (item: any) => item.contacts._id === conversationId
    )
    if (conversation) {
      dispatch(
        inboxArchiveFlag({
          receiver: conversation.receiver,
          data: {
            isFlagged: conversation.contacts.isFlagged,
            isArchived: !conversation.contacts.isArchived,
            isTicked: conversation.contacts.isTicked,
          },
        })
      ).then(() => {
        // Optimistically update the local conversation list
        dispatch({
          type: 'InboxData/updateConversationArchive',
          payload: {
            conversationId,
          },
        })
        setIsOptimisticLoading(true)

        // If the archived conversation is currently selected, clear the chat area
        if (selectedNumberId === conversationId) {
          setNumber('')
          setActiveConversationId(null)
          setSelectedNumberID('')
          setSelectedNumberTagID('')
          setMessengerName('')
        }
      })
    }
  }
  // Effect: Only stop loading after a conversation is actually removed from the list
  useEffect(() => {
    if (isOptimisticLoading && messageData?.items) {
      dispatch(stopLoading())
      setIsOptimisticLoading(false)
    }
  }, [messageData?.items, isOptimisticLoading, dispatch])

  const handleConversationFlag = (conversationId: string) => {
    // Find the conversation to get the receiver
    const conversation = messageData?.items?.find(
      (item: any) => item.contacts._id === conversationId
    )
    if (conversation) {
      dispatch(
        inboxArchiveFlag({
          receiver: conversation.receiver,
          data: {
            isFlagged: !conversation.contacts.isFlagged,
            isArchived: conversation.contacts.isArchived,
            isTicked: conversation.contacts.isTicked,
          },
        })
      ).then(() => {
        // Optimistically update the local conversation list
        dispatch({
          type: 'InboxData/updateConversationFlag',
          payload: {
            conversationId,
            isFlagged: !conversation.contacts.isFlagged,
            isArchived: conversation.contacts.isArchived,
            isTicked: conversation.contacts.isTicked,
          },
        })
        setIsOptimisticLoading(true)
      })
    }
  }

  const handleConversationMarkAsUnread = (conversationId: string) => {
    // Find the conversation to get the receiver
    const conversation = messageData?.items?.find(
      (item: any) => item.contacts._id === conversationId
    )
    if (conversation) {
      dispatch(
        inboxArchiveFlag({
          receiver: conversation.receiver,
          data: {
            isFlagged: conversation.contacts.isFlagged,
            isArchived: conversation.contacts.isArchived,
            isTicked: conversation.contacts.isTicked,
            isInboxRead: false,
          },
        })
      ).then(() => {
        fetchData(OwnerId, rmsChat, queryData, assigneeFilter)
        dispatch(InboxSmsBadge())
      })
    }
  }

  let assignedPerson = null

  const isNumberAssignedToUser = userData?.assignedContacts?.includes(selectedNumberId)

  const assignedTeamMember = Teamlist?.find((teamMember: any) =>
    teamMember?.assignedContacts?.includes(selectedNumberId)
  )
  assignedPerson = assignedTeamMember || null
  if (isNumberAssignedToUser) {
    assignedPerson = userData
  }

  return (
    <>
      {EditContact}
      {assignedTags}
      {ContactDetail}

      {/* Bulk Actions Toolbar - Floating at bottom when conversations are selected */}

      <div className='d-flex flex-column flex-lg-row h-100'>
        <div
          className='flex-column flex-lg-row-auto w-100 w-lg-300px w-xl-400px mb-10 mb-lg-0'
          style={{display: isMobile && receiver ? 'none' : ''}}
        >
          <div className='card card-flush h-100'>
            <div className='flex-nowrap card-header  p-2' id='kt_chat_contacts_header'>
              <button
                onClick={() => {
                  setRmsChat(false)
                  setNumber('')
                  setRmsId('')
                }}
                className={` btn w-100 px-4 btn-sm btn-icon m-1  text-nowrap ${!rmsChat ? 'btn-primary' : 'btn-light-primary'
                  }`}
              >
                INBOX CHAT
              </button>
              <OverlayTrigger
                placement='bottom'
                delay={{ show: 250, hide: 400 }}
                overlay={
                  <Tooltip id='tooltip-bottom'>
                    <div style={{ textAlign: 'left' }}>
                      <span>Use Record Management System (RMS) Chat to enable :</span>
                      <ul className='mb-0 ps-3 mt-3'>
                        <li>Secure communication about sensitive record</li>
                        <li>Faster internal collaboration</li>
                        <li>Audit-trail-enabled chats for compliance</li>
                      </ul>
                    </div>
                  </Tooltip>
                }
              >
                <button
                  onClick={() => {
                    setRmsChat(true)
                    setNumber('')
                    setRmsId('')
                  }}
                  className={`btn w-100 px-4 btn-sm btn-icon  m-1 text-nowrap ${rmsChat ? 'btn-primary' : 'btn-light-primary'
                    }`}
                >
                  RMS CHAT
                </button>
              </OverlayTrigger>

              {/* <input
                className='form-check-input w-45px h-30px'
                type='checkbox'
                id='allowmarketing'
                checked={rmsChat}
                onChange={() => {
                  setRmsChat(!rmsChat)
                  setNumber('')
                  setRmsId('')
                }}
              />
              <label className='form-check-label'></label> */}
            </div>
            {/* New GoHighLevel-style Header */}
            <InboxHeader
              searchInput={queryData?.searchInput || ''}
              onSearchChange={handleSearchInputChange}
              onFilterClick={() => setShowQuickFilters(true)}
              onEditClick={() => {
                /* Handle edit click */
              }}
              selectedCount={selectedConversations.length}
              onBulkActionsClick={() => setShowBulkActions(!showBulkActions)}
            />

            {/* Bulk Actions Dropdown */}
            {showBulkActions && (
              <div className='position-relative'>
                <BulkActionsDropdown
                  show={showBulkActions}
                  onClose={() => setShowBulkActions(false)}
                  selectedCount={selectedConversations.length}
                  totalCount={messageData?.items?.length || 0}
                  onAssignTo={(assignee: any) => {
                    // Handle bulk assignment
                    dispatch(
                      bulkAssignConversations({
                        conversationIds: selectedConversations,
                        assigneeId: assignee._id,
                      })
                    )
                      .then(() => {
                        fetchData(OwnerId, rmsChat, queryData, assigneeFilter)
                        toast.success(
                          `${selectedConversations.length} conversations assigned to ${assignee.name}`
                        )
                      })
                      .catch((error: any) => {
                        toast.error('Failed to assign conversations')
                      })
                  }}
                  onAddTag={(tags: string[]) => {
                    // Handle bulk tagging with selected tags
                    if (tags && tags.length > 0) {
                      // Here you would implement the actual tagging logic
                      // For now, we'll show a success message
                      toast.success(
                        `Applied ${tags.length} tag${tags.length > 1 ? 's' : ''} to ${
                          selectedConversations.length
                        } conversation${selectedConversations.length > 1 ? 's' : ''}`
                      )
                      // You can dispatch an action to apply tags to conversations
                      // dispatch(bulkApplyTags({ conversationIds: selectedConversations, tagIds: tags }))
                    } else {
                      toast.info('No tags selected')
                    }
                  }}
                  onUnsubscribe={() => {
                    // Handle bulk unsubscribe (confirmation now handled in component)
                    dispatch(
                      bulkUnsubscribeConversations({
                        conversationIds: selectedConversations,
                      })
                    )
                      .then(() => {
                        fetchData(OwnerId, rmsChat, queryData, assigneeFilter)
                        toast.success(`${selectedConversations.length} conversations unsubscribed`)
                      })
                      .catch((error: any) => {
                        toast.error('Failed to unsubscribe conversations')
                      })
                  }}
                  onArchive={() => {
                    // Handle bulk archive (confirmation now handled in component)
                    dispatch(
                      bulkArchiveConversations({
                        conversationIds: selectedConversations,
                      })
                    )
                      .then(() => {
                        fetchData(OwnerId, rmsChat, queryData, assigneeFilter)
                        toast.success(`${selectedConversations.length} conversations archived`)
                      })
                      .catch((error: any) => {
                        toast.error('Failed to archive conversations')
                      })
                  }}
                  onFlag={() => {
                    // Handle bulk flag
                    selectedConversations.forEach((conversationId: string) => {
                      const conversation = messageData?.items?.find(
                        (item: any) => item.contacts._id === conversationId
                      )
                      if (conversation) {
                        dispatch(
                          inboxArchiveFlag({
                            receiver: conversation.receiver,
                            data: {
                              isFlagged: !conversation.contacts.isFlagged,
                              isArchived: conversation.contacts.isArchived,
                              isTicked: conversation.contacts.isTicked,
                            },
                          })
                        )
                        // Optimistically update the local conversation list
                         dispatch({
                            type: 'InboxData/updateConversationFlag',
                            payload: {
                              conversationId,
                              isFlagged: !conversation.contacts.isFlagged,
                              isArchived: conversation.contacts.isArchived,
                              isTicked: conversation.contacts.isTicked,
                            },
                          })
                      }
                    })
                    setIsOptimisticLoading(true)
                    toast.success(`${selectedConversations.length} conversations flagged`)
                  }}
                  onMarkAsRead={() => {
                    // Handle bulk mark as read
                    inboxRead({
                      data: {
                        ids: selectedConversations,
                      },
                      id: groupid,
                    })
                      .then(() => {
                        fetchData(OwnerId, rmsChat, queryData, assigneeFilter)
                        toast.success(
                          `${selectedConversations.length} conversations marked as read`
                        )
                      })
                      .catch((error: any) => {
                        toast.error('Failed to mark conversations as read')
                      })
                  }}
                  onCloseAsRead={() => {
                    // Handle bulk close as read
                    inboxClose({
                      data: {
                        ids: selectedConversations,
                      },
                      id: groupid,
                    })
                      .then(() => {
                        fetchData(OwnerId, rmsChat, queryData, assigneeFilter)
                        toast.success(
                          `${selectedConversations.length} conversations closed as read`
                        )
                      })
                      .catch((error: any) => {
                        toast.error('Failed to close conversations as read')
                      })
                  }}
                  onSelectAll={(selectAll: boolean) => {
                    // Handle select all conversations
                    if (selectAll) {
                      // Select all conversations
                      const allConversationIds =
                        messageData?.items?.map((item: any) => item.contacts._id) || []
                      dispatch(selectAllConversations(allConversationIds))
                    } else {
                      // Clear all selections
                      dispatch(clearConversationSelection())
                    }
                  }}
                  teamMembers={Teamlist || []}
                  selectedConversations={selectedConversations}
                  conversationsData={messageData?.items || []}
                />
              </div>
            )}

            {/* Quick Filters Modal */}
            <QuickFiltersModal
              show={showQuickFilters}
              onHide={() => setShowQuickFilters(false)}
              onApplyFilters={(filters) => {
                // Apply the filters to the query
                let newQuery = {...queryData}

                // Clean up old message filter keys
                delete newQuery.isArchived
                delete newQuery.isBlocked
                delete newQuery.isInboxRead
                delete newQuery.isAssignToMe
                delete newQuery.isFlagged

                // Handle assignee filters
                if (filters.assignedTo === 'my-chat') {
                  newQuery.isAssignToMe = true
                  setAssigneeFilter(null)
                } else if (filters.assignedTo === 'unassigned') {
                  newQuery.isAssignToMe = false
                  setAssigneeFilter(null)
                } else if (
                  filters.assignedTo &&
                  filters.assignedTo !== 'my-chat' &&
                  filters.assignedTo !== 'unassigned'
                ) {
                  // Specific team member selected
                  setAssigneeFilter(filters.assignedTo)
                  delete newQuery.isAssignToMe
                } else {
                  delete newQuery.isAssignToMe
                  setAssigneeFilter(null)
                }

                // Handle current system message filters
                if (filters.messageFilter) {
                  let filterQuery: Record<string, any> = {}

                  switch (filters.messageFilter) {
                    case 'All Message':
                      filterQuery = {}

                      break
                    case 'Active Messages Only':
                      filterQuery = {
                        isArchived: false,
                        isBlocked: false,
                      }
                      break
                    case 'Flagged':
                      filterQuery = {
                        isFlagged: true,
                        isArchived: false,
                      }
                      break
                    case 'My Message':
                      filterQuery = {
                        isAssignToMe: true,
                      }
                      break
                    case 'Archived':
                      filterQuery = {
                        isArchived: true,
                      }
                      break
                    case 'Unread':
                      filterQuery = {
                        isInboxRead: false,
                      }
                      break
                    case 'Opened':
                      filterQuery = {
                        isInboxRead: true,
                      }
                      break
                    case 'Subscribed':
                      filterQuery = {
                        isBlocked: false,
                      }
                      break
                    case 'Unsubscribed':
                      filterQuery = {
                        isBlocked: true,
                      }
                      break
                  }

                  newQuery = {...newQuery, ...filterQuery}
                  setSelectedFilter(filters.messageFilter)
                }

                // Handle sort order
                if (filters.sortOrder) {
                  setSortOrder(filters.sortOrder)
                }
                setSearchMode(filters?.searchType ?? 'by-filter')
                setQueryData(newQuery)
                toast.success('Filters applied successfully')
              }}
              onClearFilters={() => {
                setQueryData({
                  isBlocked: false,
                  pageCount: 1,
                  searchInput: queryData?.searchInput || '',
                })
                toast.success('Filters cleared')
              }}
              teamMembers={Teamlist || []}
              currentFilters={{
                assignedTo: assigneeFilter,
                messageFilter: selectedFilter,
                searchType: searchMode,
                sortOrder: sortOrder,
              }}
            />
            {/** For Desktop View */}
            {rmsChat ? (
              <div className='card-body pt-5' id='kt_chat_contacts_body'>
                <div
                  className={`scroll-y me-n5 pe-5 ${isMobile ? 'h-75' : 'h-200px'} h-lg-auto`}
                  data-kt-scroll='true'
                  data-kt-scroll-activate='{default: false, lg: true}'
                  data-kt-scroll-max-height='auto'
                  data-kt-scroll-dependencies='#kt_header, #kt_toolbar, #kt_footer, #kt_chat_contacts_header'
                  data-kt-scroll-wrappers='#kt_content, #kt_chat_contacts_body'
                  data-kt-scroll-offset='0px'
                >
                  {rmsMessageData?.length > 0 ? (
                    rmsMessageData?.map((val: any, i: number) => {
                      const FindName = val?.fields?.[0]?.find((key: any) => {
                        const fName = key?.name?.toLowerCase()?.replace(/ +/g, '') == 'firstname'
                        const LName = key?.name?.toLowerCase()?.replace(/ +/g, '') == 'lastname'
                        const name = key?.name?.toLowerCase()?.replace(/ +/g, '') == 'fullname'
                        return fName || LName || name
                      })
                      return (
                        <div
                          key={i}
                          onClick={() => {
                            changeRmsChat(val?.rmsThreadKey)
                            setNumber(val?.subscriberNumber)
                            FindName !== undefined && setNameOfSubscriber(FindName?.value)
                            setRmsId(val?.rmsThreadKey)
                          }}
                          className='d-flex flex-stack py-4 cursor-pointer'
                        >
                          <div className='d-flex align-items-center'>
                            <div className='symbol symbol-45px symbol-circle'>
                              <span
                                className='symbol-label fs-6 fw-bolder'
                                style={{ backgroundColor: '#F4F4F4', color: '#404253' }}
                              >
                                {FindName !== undefined ? FindName.value?.split('')?.[0] : '-'}
                              </span>
                            </div>

                            <div className='ms-5'>
                              <span className='fs-5 fw-bolder text-gray-900 text-hover-primary mb-2'>
                                {FindName !== undefined ? FindName?.value : val?.subscriberNumber}
                              </span>
                              <div className='fw-bold text-gray-400'>{val?.message}</div>
                            </div>
                          </div>

                          <div className='d-flex flex-column align-items-end ms-2'>
                            <span className='text-muted fs-7 mb-1'></span>
                          </div>
                        </div>
                      )
                    })
                  ) : (
                    <NodataYet message={'No replies available'} />
                  )}
                </div>
              </div>
            ) : (
              <div className='card-body pt-5' id='kt_chat_contacts_body'>
                <div
                  className={`scroll-y me-n5 pe-5 ${isMobile ? 'h-75' : 'h-200px'} h-lg-auto`}
                  data-kt-scroll='true'
                  data-kt-scroll-activate='{default: false, lg: true}'
                  data-kt-scroll-max-height='auto'
                  data-kt-scroll-dependencies='#kt_header, #kt_toolbar, #kt_footer, #kt_chat_contacts_header'
                  data-kt-scroll-wrappers='#kt_content, #kt_chat_contacts_body'
                  data-kt-scroll-offset='0px'
                >
                  {messageData?.items?.length > 0 && (
                    <>
                      {messageData?.items?.map((val: any, i: number) => (
                        <ConversationItem
                          key={val.contacts._id}
                          conversation={val}
                          isSelected={selectedConversations?.includes(val.contacts._id) || false}
                          activeConversationId={activeConversationId}
                          isBulkActionsActive={showBulkActions}
                          onSelect={handleConversationSelect}
                          onAssign={handleConversationAssign}
                          onTag={handleConversationTag}
                          onUnsubscribe={handleConversationUnsubscribe}
                          onArchive={handleConversationArchive}
                          onClick={() => handleConversationClick(val)}
                          onFlag={handleConversationFlag}
                          onMarkAsUnread={handleConversationMarkAsUnread}
                          teamMembers={Teamlist || []}
                        />
                      ))}
                      {messageData?.pagination?.hasNextPage && (
                        <button
                          disabled={isLoading}
                          onClick={() => {
                            setLimit((data) => data + 50)
                            setIsLoading(true)
                          }}
                          className='btn w-100 px-4 btn-sm btn-icon m-1  btn-primary'
                        >
                          {isLoading ? (
                            <span className='spinner-border spinner-border-xl align-middle ms-2'></span>
                          ) : (
                            'Load More'
                          )}
                        </button>
                      )}
                    </>
                  )}
                  {
                    <div className='card mt-5 w-355px h-300px px-10 py-10'>
                      <div className='row align-items-center'>
                        <div className='No_data d-flex flex-column gap-3 align-items-center '>
                          {isLoading && !messageData ? (
                            <span className='spinner-border spinner-border-xl align-middle ms-2'></span>
                          ) : null}
                          {messageData?.items?.length < 1 && (
                            <div className='single_data'>No replies available</div>
                          )}
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            )}

          </div>
        </div>
        {messageData?.items?.length === 0 && number == '' && !rmsChat && (
          <div className='flex-lg-row-fluid ms-lg-7 ms-xl-10'>
            <div className='card inbox_scratch_sms' id='kt_chat_messenger'>
              <InsertNewData
                message={{
                  title: 'Get ready to use your inbox',
                  subtitle: `To ensure the best experience for your customers, you need to use a dedicated number (DN). This will prevent your customer from having multiple one message conversations instead of one.`,
                }}
                buttonName={{
                  name: 'Get my DN',
                  link: `/accounts/sender-id's`,
                  popup: false,
                }}
              />
            </div>
          </div>
        )}
        {rmsMessageData?.length == 0 && rmsId == '' && rmsChat && (
          <div className='flex-lg-row-fluid ms-lg-7 ms-xl-10'>
            <div className='card inbox_scratch_sms' id='kt_chat_messenger'>
              <InsertNewData
                message={{
                  title: 'Get ready to use your inbox',
                  subtitle: `To ensure the best experience for your customers, you need to use a dedicated number (DN). This will prevent your customer from having multiple one message conversations instead of one.`,
                }}
                buttonName={{
                  name: 'Get my DN',
                  link: `/accounts/sender-id's`,
                  popup: false,
                }}
              />
            </div>
          </div>
        )}
        {!isMobile && messageData?.items?.length > 0 && number === '' && !rmsChat && (
          <div className='flex-lg-row-fluid ms-lg-7 ms-xl-10'>
            <div className='card inbox_scratch_sms' id='kt_chat_messenger'>
              <NodataYet message={'Select a conversation to get started'} />
            </div>
          </div>
        )}
        {!isMobile && messageData?.items?.length > 0 && rmsId === '' && rmsChat && (
          <div className='flex-lg-row-fluid ms-lg-7 ms-xl-10'>
            <div className='card inbox_scratch_sms' id='kt_chat_messenger'>
              <NodataYet message={'Select a conversation to get started'} />
            </div>
          </div>
        )}
        {number !== '' && !rmsChat && !isLoading && (
          <div
            className='flex-lg-row-fluid ms-lg-7 ms-xl-10'
            style={{marginTop: isMobile ? '-50px' : ''}}
          >
            <div className='card inbox_scratch_sms' id='kt_chat_messenger'>
              <div
                className={`card-header ${isMobile ? 'no-padding' : ''}`}
                id='kt_chat_messenger_header'
              >
                <div className='card-title'>
                  <div className='symbol-group symbol-hover'></div>
                  <div className='d-flex flex-start flex-column me-3'>
                    <div className='d-flex gap-4 align-items-center '>
                      <div
                        onClick={() => handleShowDetailModal(number, selectedNumberId)}
                        className='fs-4 fw-bolder text-gray-900 text-hover-primary me-1 mb-1 lh-1 text-decoration-none'
                      >
                        <OverlayTrigger
                          placement='bottom'
                          overlay={<Tooltip id='button-tooltip'>View Contact Detail</Tooltip>}
                        >
                          <>
                            <div>{messengerName}</div>
                            <div className='fs-7 mt-2 fw-bold text-gray-400'>{number}</div>
                          </>
                        </OverlayTrigger>
                      </div>
                      {!isMobile ? (
                        <div className='d-flex gap-2 align-items-center'>
                          {chat?.tags
                            ?.filter((data: any) => !data?.isHidden)
                            ?.map((data: {name: string}, i: number) => (
                              <div key={i} className='inbox-tags'>
                                {data?.name}
                              </div>
                            ))}
                        </div>
                      ) : null}
                    </div>
                    <div className='mb-0 lh-1'>
                      {/* TODO: commented out first regarding active status */}
                      {/* <span className='badge badge-success badge-circle w-10px h-10px me-1'></span> */}
                      {/* <span className='fs-7 fw-bold text-gray-400'>Active</span> */}
                      <span className='fs-7 fw-bold text-gray-400'>
                        {assignedPerson ? `Assigned to: ${assignedPerson?.name}` : ''}
                      </span>
                    </div>
                  </div>
                </div>

                <div className='card-toolbar'>
                  <OverlayTrigger
                    placement='bottom'
                    overlay={
                      <Tooltip id='button-tooltip'>
                        {archive?.isFlagged ? 'Unflag' : 'Flag'} Contact
                      </Tooltip>
                    }
                  >
                    <i
                      onClick={() => {
                        dispatch(
                          inboxArchiveFlag({
                            receiver: number,
                            data: {
                              isFlagged: !archive.isFlagged,
                              isArchived: archive.isArchived,
                              isTicked: archive.isTicked,
                            },
                          })
                        ).then((res: any) => {
                           dispatch({
                              type: 'InboxData/updateConversationFlag',
                              payload: {
                                conversationId: selectedNumberId,
                                isFlagged: !archive.isFlagged,
                                isArchived: archive.isArchived,
                                isTicked: archive.isTicked,
                              },
                            })
                          dispatch(InboxSmsBadge())
                          setIsOptimisticLoading(true)
                        })
                      }}
                      className={`bi ${archive.isFlagged ? 'bi-flag-fill text-danger' : 'bi-flag'
                        } m-2 cursor-pointer`}
                    />
                  </OverlayTrigger>
                  <div className='me-n3'>
                    {/* <button
                    className='btn btn-sm btn-icon btn-active-light-primary'
                    data-kt-menu-trigger='click'
                    data-kt-menu-placement='bottom-end'
                    data-kt-menu-flip='top-end'
                  >
                    <i className='bi bi-three-dots fs-2'>
                    </i>
                  </button> */}
                    <DropdownButton
                      // menuAlign='right'
                      title={<i className='bi bi-three-dots fs-5'></i>}
                      id='dropdown-menu-align-right'
                      className='inbox-dropdown'
                      variant='outline-info'
                    >
                      {AuthenticateUser('list-sub-accounts') && true && (
                        <Dropdown drop='start'>
                          <Dropdown.Toggle
                            variant='light'
                            id='dropdown-basic'
                            className='menu-item p-3 bg-white fw-bold text-dark'
                          >
                            <span className='change_status'>
                              Assign to <i className='bi bi-chevron-right'></i>
                            </span>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {Teamlist?.map((key: any, i: number) => (
                              <Dropdown.Item
                                key={i}
                                onClick={() => {
                                  dispatch(
                                    PortalNotifiationBySuperAdmin({
                                      userTo: [key?._id],
                                      message: `A new contact is assigned to you. check this ${number} in your inbox chat`,
                                      type: 'inbox',
                                      action: 'inbox-assign',
                                      contactId: selectedNumberId,
                                    })
                                  ).then(() => {
                                    dispatch(GetAllTeamList({ ownerId: OwnerId }))
                                    dispatch(fetchAsyncUserDetails())
                                  })
                                }}
                                active={key?.assignedContacts?.find(
                                  (it: string) => it === selectedNumberId
                                )}
                              >
                                {key?.name}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      )}

                      {AuthenticateUser('create-tag') && (
                        <Dropdown.Item
                          className='menu-item p-3'
                          onClick={() => setAssignedTagsPopup(true)}
                        >
                          Add Tag
                        </Dropdown.Item>
                      )}

                      {AuthenticateUser('edit-contact') && (
                        <Dropdown.Item
                          className='menu-item p-3'
                          onClick={() =>
                            dispatch(
                              optoutContact({
                                data: {
                                  ids: selectedNumberId,
                                },
                                id: groupid,
                              })
                            )
                          }
                        >
                          Unsubscribe
                        </Dropdown.Item>
                      )}

                      {AuthenticateUser('edit-contact') && archive.isArchived ? null : (
                        <Dropdown.Item
                          className='menu-item p-3 '
                          onClick={() => {
                            dispatch(
                              inboxArchiveFlag({
                                receiver: number,
                                data: {
                                  isFlagged: archive.isFlagged,
                                  isArchived: !archive.isArchived,
                                  isTicked: archive.isTicked,
                                },
                              })
                            ).then(() => {
                              dispatch({
                                type: 'InboxData/updateConversationArchive',
                                payload: {
                                  conversationId: selectedNumberId,
                                },
                              })
                              setNumber('')
                              setIsOptimisticLoading(true)
                            })
                          }}
                        >
                          Archive
                        </Dropdown.Item>
                      )}

                      {
                        <Dropdown.Item
                          className='menu-item p-3 '
                          onClick={() => {
                            exportSingleReceiverMessage({
                              receiver: number,
                              isExport: true,
                            })
                              .unwrap()
                              .then((res: any) => {
                                toast.success('Success Export message')
                                window.open(`${API_DOMAIN}${res?.data?.downloadurl}`, '_self')
                              })
                              .catch((e) => {
                                toast.success('Failed export message')
                              })
                          }}
                        >
                          Export
                        </Dropdown.Item>
                      }
                    </DropdownButton>
                    {/* <Dropdown1 /> */}
                  </div>
                </div>
              </div>
              <InboxChatInner
                data={number}
                messengerName={messengerName}
                firstTime={firstTime}
                limit={limit}
              />
            </div>
          </div>
        )}
        {rmsMessageData?.length > 0 && number !== '' && rmsChat && (
          <div
            className='flex-lg-row-fluid ms-lg-7 ms-xl-10'
            style={{marginTop: isMobile ? '-50px' : ''}}
          >
            <div className='card inbox_scratch_sms' id='kt_chat_messenger'>
              <div className='card-header' id='kt_chat_messenger_header'>
                <div className='card-title'>
                  <div className='symbol-group symbol-hover'></div>
                  <div className='d-flex justify-content-center flex-column me-3'>
                    <a
                      href='#'
                      className='fs-4 fw-bolder text-gray-900 text-hover-primary me-1 mb-2 lh-1'
                    >
                      {nameOfSubscriber ? nameOfSubscriber : number}
                    </a>

                    <div className='mb-0 lh-1'>
                      <span className='badge badge-success badge-circle w-10px h-10px me-1'></span>
                      <span className='fs-7 fw-bold text-gray-400'>Active</span>
                    </div>
                  </div>
                </div>

                <div className='card-toolbar'>
                  <div className='me-n3'>
                    <button
                      className='btn btn-sm btn-icon btn-active-light-primary'
                      data-kt-menu-trigger='click'
                      data-kt-menu-placement='bottom-end'
                      data-kt-menu-flip='top-end'
                    >
                      <i className='bi bi-three-dots fs-2'></i>
                    </button>
                    {/* <Dropdown1 /> */}
                  </div>
                </div>
              </div>
              <RmsInbox data={number} rmsdata={rmsChat ? rmsSingleData : []} />
            </div>
          </div>
        )}
      </div>
    </>
  )
}
export default InboxPage
